import { createContext } from "react";
import { SimpleEntryStore } from "../../store";

export const SimpleEntryContext = createContext<SimpleEntryStore | null>(null);
